import { useEffect, useRef } from "react";
import mixpanel from "mixpanel-browser";

import config from "~/config";

type EventType =
  | "Render Signup page"
  | "Submit Signup form"
  | "Submit Signup form success"
  | "Render Payment Modal"
  | "Click On Appointment Phone Number"
  | "Render Homepage"
  | "Render Survey Page"
  | "Render Survey Transition Page"
  | "Render Results Page";

export const track = (
  eventName: EventType,
  props?: Record<string, unknown>,
) => {
  // console.log("track", { eventName, props });
  if (config.MIXPANEL_TOKEN === undefined) {
    return;
  }
  try {
    mixpanel.track(eventName, props);
  } catch (e) {
    console.error("tracking error", e);
  }
};

export const useTrackOnce = (
  eventName: EventType,
  props?: Record<string, unknown>,
) => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (!hasRun.current) {
      track(eventName, props);
      hasRun.current = true;
    }
  }, [eventName, props]);
};
